export default __webpack_public_path__ + "static/media/icon_tyokalut.e8794dba.svg";